import { ReactElement } from "react"
import { MsgDialogProps } from "../components/PublicDialogs/MsgDialog"

export function hideMsgDialog() {
    return {
        type: "HIDE_DIALOG"
    }
}

export function showMsgDialog(body: string | ReactElement | ReactElement[], title?: string, onClose?: () => void, ok?: (strResult: string) => void,
    closeLabel?: string, extraButtons?: any[], confirmMsg?: string, label?: string, defValue?: string) {
    let diaolgData: MsgDialogProps = {
        title,
        body,
        onClose,
        show: true,
        ok,
        closeLabel,
        extraButtons,
        confirmMsg,
        label,
        defValue
    }
    return {
        type: "SHOW_DIALOG",
        diaolgData
    }
}

const initialState: MsgDialogProps = {
    title: "",
    body: "",
    onClose: undefined,
    show: false,
    ok: undefined,
    closeLabel: "Close",
    extraButtons: [],
    confirmMsg: "",
    label: ""
}

export default function msgDialogReducer(msgDialog = initialState, action: any) {
    switch (action.type) {
        case "SHOW_DIALOG":
            return action.diaolgData
        case "HIDE_DIALOG":
            return { ...msgDialog, show: false }
        default:
            return msgDialog
    }
}